import React from "react";

function MovieCard({ movie, isFavorite, toggleFavorite, openTrailer }) {
  return (
    <div className="movie-card">
      <img src={movie.poster} alt={movie.title} className="poster" />

      <div className="movie-info">
        <h3>{movie.title}</h3>
        <p>📅 {movie.year}</p>
        <p>⭐ {movie.rating}</p>
        <p>🎭 {movie.genre}</p>

        <div className="actions">
          <button onClick={() => openTrailer(movie.trailer)}>
            ▶ Play
          </button>

          <button onClick={() => toggleFavorite(movie.title)}>
            {isFavorite ? "❤️" : "🤍"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MovieCard;